import { render, staticRenderFns } from "./QuotaSummary.vue?vue&type=template&id=8ec0ea06&"
import script from "./QuotaSummary.vue?vue&type=script&lang=js&"
export * from "./QuotaSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports